/**
 * CMS 运行时地址
 * - 本地开发：由 vue.config.js 的 devServer 代理 /cms-api、/cms-media 到 http://localhost:3001
 * - 生产 nginx：把 /kanban/cms-api/ 反代到内容服务的 /api/，/kanban/cms-media/ 反代到 /media/
 * - Electron 离线包：服务不可用时静默回落到本地默认内容，页面照常显示
 */
const PUB = process.env.VUE_APP_PUBLIC_PATH || '/'
const norm = p => (p && p.endsWith('/') ? p : p + '/')

export const CMS_API_BASE = norm(PUB) + 'cms-api'
export const CMS_MEDIA_BASE = norm(PUB) + 'cms-media'

/** 素材完整访问地址：后台存的是 /media/image/xxx.png（服务端 /media 静态目录相对地址）。
 *  前端经 /cms-media（dev 代理 / 生产 nginx）反代到服务端 /media，故此处去掉存储值里已带的 /media 前缀，
 *  只保留其后的路径片段，避免 /media 前缀重复（否则会变成 /cms-media/media/... → 404）。 */
export function mediaUrl(path) {
  if (!path) return ''
  if (/^(https?:)?\/\//.test(path) || path.startsWith('data:')) return path
  let p = path.startsWith('/') ? path : '/' + path
  p = p.replace(/^\/media/, '')
  if (!p.startsWith('/')) p = '/' + p
  return CMS_MEDIA_BASE.replace(/\/$/, '') + p
}

export const CONTENT_SOURCE = {
  api(method) {
    return CMS_API_BASE + method
  },
}
